import Vendor from './components';

export default {
  protected: true,
  path: '/vendors/:vendorId',
  key: '/vendor/',
  exact: true,
  component: Vendor,
};
